
import { Component, Vue } from 'vue-property-decorator'
import { IMockTopPage, MOCK_TOP_PAGE } from '@/constants/monitor-mock'

@Component({ name: 'DashboardTopPageTable' })
export default class DashboardTopPageTable extends Vue {
    private rows: IMockTopPage[] = MOCK_TOP_PAGE

    /** 行点击：模块一仅路由到页面分析占位页，模块二接入下钻 */
    private onClick(row: IMockTopPage) {
        this.$router.push('/monitor/page').catch(() => { /* 路由已注册 */ })
    }

    private formatNumber(n: number): string {
        return n.toLocaleString()
    }
}
